let formaturl = {
  formaturl(file) {
    return require('@/components/' + file + '.vue').default
    // console.log('输出new信息:', data);
  } // vue-loader at least v13.0.0+
}
// export default formaturl
module.exports = formaturl



// WEBPACK FOOTER //
// ./src/router/import_development.js